import UAParser from 'ua-parser-js';
import { isSessionCheck } from '../../../../shared/client/isSessionCheck.ts';
import { $qs } from 'fxdom/es';

window._en = window.ENV.lang == 'kr' ? '' : `_${window.ENV.lang}`;
window._collabo = collabo_type == '' ? '' : `_${collabo_type}`;

if (!window.box) {
  window.box = _p.box(ENV.box);
  delete window.ENV.box;
}

window.fbAsyncInit = function () {
  FB.init({
    appId: ENV.appId,
    xfbml: true,
    version: 'v8.0',
  });
  FB.AppEvents.logPageView();
};

(function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  const js = d.createElement(s);
  js.id = id;
  js.src = 'https://connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

G.change_window(isSessionCheck);

const html_el = $qs('html');
const type = new UAParser().getDevice().type;

$.on(window, 'resize', function () {
  if (type == new UAParser().getDevice().type) return;
  $.hide(html_el);
  window.location.reload();
});

$.add_class(html_el, G.is_mobile_size() ? 'is_mobile_size' : 'is_pc_size');
